import { render, staticRenderFns } from "./IdramPayments.vue?vue&type=template&id=2187b0b5"
import script from "./IdramPayments.vue?vue&type=script&lang=js"
export * from "./IdramPayments.vue?vue&type=script&lang=js"
import style0 from "./IdramPayments.vue?vue&type=style&index=0&id=2187b0b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports